export default __webpack_public_path__ + "static/media/movie6.337d8096.png";